import {getBackend} from "../router/getters";

const getStorageKey = (key: string, backend = '') => {
    backend = backend ? backend : getBackend();
    return process.env.VUE_APP_SERVER + key + backend;
}

const sessionKey = (backend = '') => {
    return getStorageKey('_session_', backend);
}

const interfaceStateKey = (userId: number, backend = '') => {
    return getStorageKey(`_interface-state_${userId}_`, backend);
}

const servicesKey = (backend = '') => {
    return getStorageKey('_services_', backend);
}

const welcomeTourKey = (backend = '') => {
    return getStorageKey('_welcome_', backend)
}

const commonCssKey = (backend = '') => {
    return getStorageKey('_common-css_', backend)
}

export {
    sessionKey,
    servicesKey,
    interfaceStateKey,
    welcomeTourKey,
    commonCssKey
}
